import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import {buildApiQueryError, type QueryError} from "../util/errorUtil";
import type {ApiQueryError} from "./types";

export interface QualityFurnishingsOutputs {
    nhk_crafts_matrix: unknown;
    nhk_crafts_based_furnishings: number | null;
}

interface ObjectInformationState {
    modernizationDegreeError: ApiQueryError | null;
    qualityFurnishingsError: ApiQueryError | null;
    /** Nur angezeigte, nie gespeicherte QUALITY_FURNISHINGS-Antwort (#19507). */
    qualityFurnishingsPreview: QualityFurnishingsOutputs | null;
}

const initialState: ObjectInformationState = {
    modernizationDegreeError: null,
    qualityFurnishingsError: null,
    qualityFurnishingsPreview: null,
};

/**
 * Fehlerstatus der abgeleiteten AVM-Inputs aus MODERNIZATION_DEGREE und QUALITY_FURNISHINGS
 * (#19376) — beide Endpunkte laufen "fail hard": ein Fehler wird hier sichtbar gebannert statt
 * still verschluckt.
 */
const objectInformationSlice = createSlice({
    name: "objectInformation",
    initialState,
    reducers: {
        setModernizationDegreeError: (state, action: PayloadAction<QueryError | null>) => {
            state.modernizationDegreeError = action.payload ? buildApiQueryError(action.payload) : null;
        },
        setQualityFurnishingsError: (state, action: PayloadAction<QueryError | null>) => {
            state.qualityFurnishingsError = action.payload ? buildApiQueryError(action.payload) : null;
        },
        setQualityFurnishingsPreview: (state, action: PayloadAction<QualityFurnishingsOutputs | null>) => {
            state.qualityFurnishingsPreview = action.payload;
        },
        resetObjectInformation: () => initialState,
    },
    selectors: {
        selectModernizationDegreeError: (state) => state.modernizationDegreeError,
        selectQualityFurnishingsError: (state) => state.qualityFurnishingsError,
        selectQualityFurnishingsPreview: (state) => state.qualityFurnishingsPreview,
    },
});

export const {
    setModernizationDegreeError,
    setQualityFurnishingsError,
    setQualityFurnishingsPreview,
    resetObjectInformation,
} = objectInformationSlice.actions;
export const {selectModernizationDegreeError, selectQualityFurnishingsError, selectQualityFurnishingsPreview} =
    objectInformationSlice.selectors;
export default objectInformationSlice.reducer;
